﻿/**
* DevExpress Analytics (property-grid\widgets\registerBaseEdtior.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var editorsInfo_1 = require("./editorsInfo");
var editor_1 = require("./fonteditor/editor");
var propertygrid_1 = require("../propertygrid");
function registerBaseEditors() {
    editorsInfo_1.editorTemplates.registerEditors({
        'bool': { header: 'dx-boolean' },
        'boolSelect': { header: 'dx-boolean-select' },
        'numeric': { header: 'dx-numeric' },
        'modificators': { custom: 'dx-modificators' },
        'combobox': { header: 'dx-combobox' },
        'comboboxEditable': { header: 'dx-combobox-editable' },
        'text': { header: 'dx-text' },
        'image': { header: 'dx-image' },
        'file': { header: 'dx-file' },
        'commonCollection': { custom: 'dx-commonCollection' },
        'stringArray': { header: 'dx-emptyHeader', content: 'dx-string-array' },
        'font': { header: 'dx-emptyHeader', content: 'dx-objectEditorContent', editorType: editor_1.FontEditor },
        'objecteditor': { header: 'dx-emptyHeader', content: 'dx-objectEditorContent', editorType: propertygrid_1.PropertyGridEditor },
        'inplaceObjectEditor': { custom: 'dx-objectEditorContent', editorType: propertygrid_1.PropertyGridEditorFlat }
    });
}
exports.registerBaseEditors = registerBaseEditors;
